import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; // Make sure you have this import for icons
import './DashboardSidebar.css';
import logo from '../Logo/logo2-Photoroom.png'; 

// Minimized labels for a cleaner look
const navItems = [
  { label: 'Dashboard', icon: 'bi-grid-1x2', path: '/Manager/ManagerDashboard' },
  { label: 'Brokers', icon: 'bi-briefcase', path: '/Manager/ManageBroker' },
  { label: 'AssignForm', icon: 'bi-house',  path: '/Manager/ManagerAssignForm'  },
  // { label: 'Forms', icon: 'bi-receipt', path: '/ManagerBrokerForm' },
  { label: 'Submission', icon: 'bi-journal-text', path: '/Manager/Submission' },
  { label: 'Management', icon: 'bi-bar-chart', path: '/management' },
  { label: 'Profile', icon: 'bi-person', path: '/Manager/ManagerProfile' },


];

const DashboardSidebar = () => {
  const location = useLocation();

  const handleLogout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  sessionStorage.clear();
  window.location.href = '/';
};

  return (
    <nav className="dashboard-sidebar">
       <img src={logo} alt="Logo" style={{height:"100px", width:"100px", marginLeft:"45px"}}/> 
      <hr />
      <ul className="nav-list">
        {navItems.map((item) => (
          <li className="nav-item" key={item.label}>
            {item.path && !item.disabled ? (
              <Link
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </Link>
            ) : (
              <span className="nav-link disabled">
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </span>
            )}
          </li>
        ))}
      </ul>
      <div className="logout-section">
        <button type="button" className="nav-link logout-button" onClick={handleLogout}  style={{background : "red", border: "none", color: "white"}}>
          <i className="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default DashboardSidebar;